import { ACTcodes } from "../data/ATC";

export function getNameWithATC(atcCode: string): string | null {

  if(atcCode.length !== 7) return null
  return ACTcodes.find((code: any) => code.id === atcCode)?.title as string;
}
